import React from 'react'
import Free_Consultation from '../../home/free-consultation/Free_Consultation'
import Inner_Page_Banner from './inner-page-banner/Inner_Page_Banner'
import Include_Services from './include-services/Include_Services'
import Key_Benefits from './key-benefits/Key_Benefits'
import Rooftop_Solar from './rooftop-solar/Rooftop_Solar'

const Service_Inner_Page = () => {
    return (
        <>
            <Inner_Page_Banner />
            <Include_Services />
            <Key_Benefits />
            <Free_Consultation />
            <Rooftop_Solar />
        </>
    )
}

export default Service_Inner_Page